import React from 'react';

export const Tabs = ({
  tabs, // array of { id, label, icon, badge }
  activeTab,
  onChange,
  className = ''
}) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px',
        backgroundColor: 'var(--surface-recessed)',
        boxShadow: 'var(--shadow-recessed-sm)',
        borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--border-subtle)',
        gap: '4px',
        maxWidth: '100%',
        overflowX: 'auto'
      }}
      className={className}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '7px 14px',
              borderRadius: 'var(--radius-md)',
              fontSize: '13px',
              fontWeight: isActive ? '650' : '450',
              color: isActive ? 'var(--accent-teal)' : 'var(--text-secondary)',
              backgroundColor: isActive ? 'var(--surface-card)' : 'transparent',
              boxShadow: isActive ? 'var(--shadow-raised-sm)' : 'none',
              border: isActive ? '1px solid var(--border-subtle)' : '1px solid transparent',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              transition: 'all 0.18s cubic-bezier(0.4, 0, 0.2, 1)',
              fontFamily: 'var(--font-body)'
            }}
          >
            {tab.icon && <span style={{ display: 'inline-flex' }}>{tab.icon}</span>}
            {tab.label}
            {tab.badge !== undefined && (
              <span
                style={{
                  fontSize: '11px',
                  fontWeight: '700',
                  padding: '1px 6px',
                  borderRadius: '999px',
                  backgroundColor: isActive ? 'rgba(35, 190, 179, 0.2)' : 'var(--surface-alt)',
                  color: isActive ? 'var(--accent-teal)' : 'var(--text-muted)'
                }}
              >
                {tab.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
